var modules_51430e0a = {"container":"MenuItem_module_container__57fd1c30","searchContainer":"MenuItem_module_searchContainer__57fd1c30"};
import "../../assets/esm/components/SuggestList/MenuItem~CDjHqm3o.css";

export { modules_51430e0a as default };
//# sourceMappingURL=MenuItem.module.less.js.map
